import { type HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';



export const authInterceptor: HttpInterceptorFn = (req, next) => {

    // Clave con prefijo del portal para no mezclar tokens entre portales
    const tokenKey = `redi_${environment.portal}_token`;
    const token = localStorage.getItem(tokenKey);

    if (token) {
        const authReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
        return next(authReq);
    }

    return next(req);
};
